// Numeric-input sanitizer: digits + a single decimal point.
export const numOnly = (v: string): string => {
  let out = v.replace(/[^0-9.]/g, '');
  const i = out.indexOf('.');
  if (i !== -1) out = out.slice(0, i + 1) + out.slice(i + 1).replace(/\./g, '');
  return out;
};
